import React from "react";
import InvestmentsPage from "../Portfolio/InvestmentsPage";
import DemoCTA from "./DemoCTA";
import { useDemo } from "./DemoContext";

export default function DemoInvestmentsTab() {
    const { visibleHoldings } = useDemo();

    return (
        <div className="space-y-6">
            <InvestmentsPage holdings={visibleHoldings} />
            <DemoCTA variant="inline" />
        </div>
    );
}
